import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Checkbox, message } from "antd";
import { MailOutlined, LockOutlined,  LoginOutlined } from "@ant-design/icons";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { loginUser, getCurrentUser } from "../../../core/redux/auth.slice";
import { getRouteByShopContext } from "../../../core/utils/permissions";
import { socketService } from "../../../core/services/socket.service";

const Signin = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

// const getLandingRouteByRole = (roles) => {
//   if (!roles || roles.length === 0) return "/signin";

//   if (roles.includes("ADMIN") || roles.includes("MANAGER") || roles.includes("ASSISTANT MANAGER")) {
//     return "/all/admin-dashboard";            // back-office
//   }

//   if (roles.includes("PRODUCTION MANAGER")) {
//     return "/all/stock-production";           // exemple
//   }

//   if (roles.includes("SELLER")) {
//     return "/all/pos";                        // ou directement route POS
//   }

//   return "/signin";
// };


  const onFinish = async (values) => {
  try {
    await dispatch(loginUser(values)).unwrap();
    const currentUser = await dispatch(getCurrentUser()).unwrap();

    //   NOUVEAU : connecter SignalR après login réussi
    socketService.setUserContext(currentUser);
    // shopId : si l'utilisateur a un seul shop on l'utilise, sinon on connecte sans shop
    const shopId = currentUser?.shopIds?.length === 1 ? currentUser.shopIds[0] : null;
    await socketService.connect(shopId);

    let basePath = "/:shopId/";
    const roles = currentUser?.roles || [];

    if (roles.includes("SUPERADMIN")) {
      basePath = "admin-dashboard";
    } else if (roles.includes("PRODUCTION MANAGER")) {
      basePath = "manage-stocks";
    } else if (roles.includes("ADMIN")) {
      basePath = "general-settings";
    } else {
      basePath = "sales-list";
    }

    const targetRoute = getRouteByShopContext(currentUser, basePath);
    navigate(targetRoute, { replace: true });
  } catch (err) {
    message.error(error || "Login failed");
  }
};


  useEffect(() => {
    if (error) {
      message.error(error);
    }
  }, [error]);

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-content authent-content">
            <Form form={form} name="login" onFinish={onFinish} layout="vertical">
              <div className="login-userset">
                <div className="login-logo logo-normal">
                    <ImageWithBasePath src="assets/img/logo-tablineo-500.png" alt="img" />

                </div>

                <div className="login-userheading" style={{ alignItems: 'center' }}>
                  <h2>Se connecter</h2>

                </div>

                <Form.Item
                  name="email"
                  label={
                    <span style={{ fontSize: '1.1rem', fontWeight: 600, color: '#1F2E36' }}>
                      Nom d&apos;utilisateur :
                    </span>
                  }
                  rules={[{ required: true, message: "Veuillez saisir votre e-mail ou nom d'utilisateur" }]}
                >
                  <Input prefix={<MailOutlined />} />
                </Form.Item>

                <Form.Item
                  name="password"
                  label={
                    <span style={{ fontSize: '1.1rem', fontWeight: 600, color: '#1F2E36' }}>
                      Mot de passe :
                    </span>
                  }
                  rules={[{ required: true, message: "Veuillez saisir votre mot de passe!" }]}
                >
                  <Input.Password prefix={<LockOutlined />} />
                </Form.Item>


                <div className="row" style={{ marginBottom: '20px' }}>
                  <div className="col-12 d-flex align-items-center justify-content-end">
                    <Form.Item
                      name="remember"
                      valuePropName="checked"
                      noStyle

                    >
                      <Checkbox>Se souvenir de moi</Checkbox>
                    </Form.Item>
                  </div>
                </div>



                <Form.Item>

                  <Button type="primary"
                    htmlType="submit"
                    className="btn btn-primary w-100"
                    style={{ fontWeight: 'bold', fontSize: '18px', height: '40px' }}
                    loading={loading}
                  >
                    <>
                      <LoginOutlined />
                      <span style={{ marginLeft: '8px' }}>Connexion</span>
                    </>

                  </Button>


                </Form.Item>
              
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p style={{color: '#514437'}}>Copyright © 2026 Tablineo.com</p>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;

